import { http } from '@lib/api';
import type { ListPage } from './list-envelope';
import type { components } from '@/types/api.generated';
import { toApiListParams, type ListRequestParams } from './list-request';
import { PRODUCT_FILTERS } from './filters.generated';

// The `/api/products` filter whitelist is codegen from the backend
// `productListConfig.filterable` via the OpenAPI `x-filterable` extension
// (issue #1407). Re-exported here so the `@/services/products` import path
// is unchanged; edit the backend config, not this file.
export { PRODUCT_FILTERS };

/**
 * Product row type = the generated OpenAPI component (ADR-0006 route-is-
 * spec; #1405 type-chain closure) — a backend field rename now fails `tsc`
 * instead of silently rendering `undefined`. The `/api/products` wire
 * intentionally omits the ingest-side extras the old hand-written
 * interface carried (`body_html`, `seo_*`, `raw_data`, provenance
 * columns); their dead consumers were deleted alongside this binding.
 */
export type Product = components['schemas']['Product'];

export const productAPI = {
  async getProducts(params?: ListRequestParams): Promise<ListPage<Product>> {
    return http.get<ListPage<Product>>('/api/products', {
      params: toApiListParams(params ?? {}, PRODUCT_FILTERS),
    });
  },

  async getProduct(id: string): Promise<Product> {
    return http.get<Product>(`/api/products/${id}`);
  },
};
